import {
	GetMemberLoginHistoryRequest,
	GetMemberLoginHistoryResponse,
} from '@/modules/manage-member/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getMemberLoginHistory } from '../../services'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'

export default function useQueryGetMemberLoginHistory(
	payload: GetMemberLoginHistoryRequest,
	props?: UseBaseQueryOptions<GetMemberLoginHistoryResponse>,
) {
	return useQuery({
		queryKey: [OperatorQueryKeys.GetMemberLoginHistory, payload],
		queryFn: () => getMemberLoginHistory(payload),
		...props,
	})
}
